import { learningDay } from "./activity";

/** No page chunk or database access is needed to rescue an in-memory backup. */
export function downloadBackup(backup: unknown, prefix = "fls-learning") {
  const json = JSON.stringify(backup, null, 2);
  if (json === undefined) throw new Error("没有可导出的学习记录");
  const url = URL.createObjectURL(
    new Blob([json], { type: "application/json" }),
  );
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = `${prefix}-${learningDay(Date.now())}.json`;
    link.click();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
